module.exports = __webpack_public_path__ + "static/img/til01.d4df92e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til01.png
// module id = ABmo
// module chunks = 1